import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// 配列シャッフル関数
function shuffleArray(array) {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

// MatchingProblemコンポーネント
const MatchingProblem = ({ question, answered, isTimeUp, handleSubmit, quickAnswerMode = 'standard' }) => {
  const [userMatches, setUserMatches] = useState(Array(question.leftItems.length).fill(''));
  const [shuffledRightItems, setShuffledRightItems] = useState([]);

  // フォームの無効化状態を判定
  const isDisabled = answered || isTimeUp;

  useEffect(() => {
    const shuffled = shuffleArray([...question.rightItems]);
    setShuffledRightItems(shuffled);
  }, [question.rightItems]);

  const handleChange = (leftIndex, rightItem) => {
    if (isDisabled) return;
    const newMatches = [...userMatches];
    newMatches[leftIndex] = rightItem;
    setUserMatches(newMatches);
  };

  const onSubmit = () => {
    if (isDisabled) return;
    const isCorrect = question.leftItems.every((li, i) => {
      const userRightItem = userMatches[i];
      const cri = question.correctMatches[i];
      const correctRightItem = question.rightItems[cri];
      return userRightItem === correctRightItem;
    });
    const correctAnswer = question.leftItems.map((li, i) => {
      const cri = question.correctMatches[i];
      return `${li} - ${question.rightItems[cri]}`;
    }).join(', ');
    handleSubmit(isCorrect, question.explanation, correctAnswer);
  };

  return (
    <div className={isDisabled ? 'opacity-70' : ''}>
      <h3 className="text-xl font-semibold text-purple-900 mb-4">{question.question}</h3>
      {question.leftItems.map((leftItem, index) => (
        <div key={index} className="mb-4">
          <label className="block text-sm font-medium text-purple-700 mb-1">
            {leftItem}
          </label>
          <select
            value={userMatches[index]}
            onChange={(e) => handleChange(index, e.target.value)}
            className={`w-full p-2 border rounded ${isDisabled ? 'cursor-not-allowed' : ''}`}
            disabled={isDisabled}
            aria-label={`左項目 ${leftItem} の選択肢`}
          >
            <option value="">選択してください</option>
            {shuffledRightItems.map((rightItem, idx) => (
              <option key={idx} value={rightItem}>{rightItem}</option>
            ))}
          </select>
        </div>
      ))}

      <div className="flex justify-end mt-4">
        <button
          onClick={onSubmit}
          className={`px-4 py-2 rounded-lg 
            ${isDisabled ? 'bg-gray-200 text-gray-500 cursor-not-allowed' : 'bg-purple-600 text-white hover:bg-purple-700'}`}
          disabled={isDisabled || userMatches.includes('')}
          aria-label="回答を送信するボタン"
        >
          回答する
        </button>
      </div>
    </div>
  );
};

MatchingProblem.propTypes = {
  question: PropTypes.object.isRequired,
  answered: PropTypes.bool.isRequired,
  isTimeUp: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  quickAnswerMode: PropTypes.string,  // クイック回答モード設定
};

export default MatchingProblem; 